/**
 * SurveyJS Serializer extensions shared across all AD survey forms.
 * Import this module once to register all custom properties on SurveyJS question types.
 */
import { Serializer } from "survey-core";

// Custom "other" value property for dropdown, radiogroup, and checkbox
Serializer.addProperty("dropdown", { name: "adOtherValue:string" });
Serializer.addProperty("radiogroup", { name: "adOtherValue:string" });
Serializer.addProperty("checkbox", { name: "adOtherValue:string" });

// Linked demographic dsm_code that should receive the typed "Other" free-text.
// When set (checkbox / slider-toggle questions map to the "checkbox" type), the typed
// Other value is saved to this separate custom attribute (e.g. "Company size - Other")
// instead of only being stored back on the question itself. Preserved from the form JSON
// so it is readable at getSurveyData() time.
Serializer.addProperty("checkbox", { name: "adOtherLinkedCode:string" });

// Display layout (1-column / 2-column) for multi-answer question types.
// The backend emits `displayColumn` (1 or 2) for radio, checkbox and slider-toggle
// questions (never boolean). Radio maps to a "radiogroup" question; both checkbox and
// slider-toggle map to a "checkbox" question. Registering the property here ensures
// SurveyJS preserves it when parsing the form JSON so it is readable at render time.
Serializer.addProperty("radiogroup", { name: "displayColumn:number" });
Serializer.addProperty("checkbox", { name: "displayColumn:number" });

// DPA (Data Protection / consent) recognition flags. The backend emits `isDpa: true` and
// `displayChannelsAs` ("single" | "separate") on a DPA question's element. Registering them
// here ensures SurveyJS preserves them when parsing the form JSON so the render path can
// read them. A DPA question renders as the standard checkbox/radio control; the only
// DPA-specific behaviour is that the consent control is never labelled "Optional".
["radiogroup", "checkbox"].forEach(type => {
    Serializer.addProperty(type, { name: "isDpa:boolean", default: false });
    Serializer.addProperty(type, { name: "displayChannelsAs:string" });
});

// Data endpoint property for dynamic choice loading
Serializer.addProperty("dropdown", { name: "dataEndpoint:string" });

// Answer code prefix for text-based question types
["text", "comment", "date", "datetime", "dropdown"].forEach(type => {
    Serializer.addProperty(type, { name: "answerCode:string" });
});

// "addItem" property triggers the custom react-select Creatable renderer
Serializer.addProperty("dropdown", {
    name: "addItem",
    type: "boolean",
    onSetValue: (surveyElement, value) => {
        surveyElement.setPropertyValue("addItem", value);
        if (value) {
            surveyElement.renderAs = "dropdown-react";
        } else {
            surveyElement.renderAs = "default";
        }
    },
});
